const translates = {
	en: {
		modalTitle: 'Create new patient',
	},
	ru: {
		modalTitle: 'Создать нового пациента',
	}
};
export default translates;